export default {
    divider: {
        or: 'ILI',
    },
}
